import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import VendorPurchaseUnitList from './VendorPurchaseUnitList';
import VendorAddAutoComplete from '../common/AutocompleteText';
import Modal from '../common/Modal';
import request from '../../helpers/request';
import itemConfig from '../items/config/itemConfig';
import config from './config/purchaseUnitConfig';
import setViewTitle from '../../helpers/setViewTitle';

var PurchaseUnits = createReactClass({

  getInitialState() {

    return {
      itemId: this.props.match.params.itemId,
      item: {
        vendors: []
      },
      removeVendor: {},
      removePurchaseUnit: {}
    };
  },

  componentWillMount() {
    setViewTitle('Artikellieferanten');

    request.get({
      url: itemConfig.apiUrl + this.state.itemId,
      success: item => {
        if (this.isMounted()) {
          this.setState({
            item
          });

          setViewTitle('Lieferanten für ' + this.state.item.name);
        }
      }
    });
  },

  componentDidMount() {

  },

  handleRemoveVendor(vendor) {
    this.setState({
      removeVendor: vendor
    }, () => this.removeVendorModal.show());
  },

  handleConfirmRemoveVendor(vendor) {
    var itemId = this.state.itemId;
    request.del({
      url: config.apiUrl + itemId + '/vendors/' + vendor.id,
      success: item => {
        this.setState({ item: item });
        this.removeVendorModal.hide();
      }
    });
  },

  handleRemovePurchaseUnit(vendor, unit) {
    this.setState({
      removeVendor: vendor,
      removePurchaseUnit: unit
    }, () => this.removePurchaseUnitModal.show());
  },

  handleConfirmRemovePurchaseUnit(vendor, unit) {
    var itemId = this.state.itemId;
    request.del({
      url: config.apiUrl + itemId + '/units/' + unit.unitId,
      success: item => {
        this.setState({ item });
        this.removePurchaseUnitModal.hide();
      }
    });
  },

  onVendorSelected(selectedVendor) {
    var alreadyHasVendor = this.state.item.vendors.some(x => x.id === selectedVendor.id);
    if (alreadyHasVendor) {
      return;
    }

    var vendor = {
      id: selectedVendor.id,
      vendorName: selectedVendor.name,
      purchaseUnits: []
    };

    let item = this.state.item;
    item.vendors.push(vendor);

    this.setState({
      item
    });

    this._vendorAddAutocomplete.resetSelection();
  },

  render() {
    var vendorFastSearchUrl = config.apiUrl + this.state.itemId + '/vendorsearch';

    let {removeVendor, removePurchaseUnit} = this.state;
    let { history } = this.props;

    return (
      <div>
        <div className="col-md-12">
          <div className="row">
            <VendorAddAutoComplete
              ref={c => this._vendorAddAutocomplete = c}
              dataUrl={vendorFastSearchUrl}
              onSelect={this.onVendorSelected}
              searchPlaceholder="Artikellieferanten hinzufügen"
              idProp="id"
              displayProp="name"
              inputTooShortText="Geben Sie mind. 2 Zeichen ein"
              noMatchesText="Kein Ergebnis"
              searchInProgressText="Suche..."
            />
          </div>
          <br />
          <div className="row">
            <VendorPurchaseUnitList itemId={this.state.item.id} vendors={this.state.item.vendors} removeVendor={this.handleRemoveVendor} removeUnit={this.handleRemovePurchaseUnit} history={history} />
          </div>
          <div className="smart-form">
            <footer>
              <Link to={`/items/${this.state.itemId}`} className="btn btn-default">Zurück</Link>
            </footer>
          </div>
        </div>

        <div className="clearfix"></div>

        <Modal
          ref={c => this.removeVendorModal = c}
          title="Lieferant löschen?"
          message={`Soll der Artikellieferant '${removeVendor.vendorName}' wirklich gelöscht werden? Auch die Bestelleinheit gehen dabei verloren.`}
          confirmButtonText="Ja, löschen"
          onConfirm={() => this.handleConfirmRemoveVendor(removeVendor)}
        />

        <Modal
          ref={c => this.removePurchaseUnitModal = c}
          title="Bestelleinheit löschen?"
          message={`Soll die Bestelleinheit '${removePurchaseUnit.name}' des Lieferanten '${removeVendor.vendorName}' wirklich gelöscht werden?`}
          confirmButtonText="Ja, löschen"
          onConfirm={() => this.handleConfirmRemovePurchaseUnit(removeVendor, removePurchaseUnit)}
        />
      </div>
    );
  }
});

export default PurchaseUnits;



// WEBPACK FOOTER //
// ./src/components/purchaseunits/PurchaseUnits.js